import React, { useMemo, useState, useEffect } from "react";
import { Select, Popover, Checkbox, Button, Input, Tooltip } from "antd";
import { useDispatch, useSelector } from "react-redux";
import isEqual from "react-fast-compare";
import { setY_attribute } from "../../../../redux/actions/WidgetMaker/GraphConfig";
import {
  getPaneIndex,
  getWindowLocationPath,
} from "../../../../redux/constants";
import quickFilterIcon from "../../../../assets/QuickFilterIcon.svg";
import "./FilterByDropDown.scss";
const FilterByDropDown = ({
  dropDownData,
  filterIndex = 0,
  metadata = null,
  section_index,
  widget_index,
  deepDive,
  isPreviewState = false,
  PdfDownloadStatus = false,
  PptGeneratingStatus = false,
  widget_id,
  chart_type,
  isMultiple = true,
  type,
}) => {
  const dispatch = useDispatch();
  // Handle popover visibility
  const [visible, setVisible] = useState(false);

  // Function to handle visibility change of tooltip
  const [visibleOfTooltip, setVisibleOfTooltip] = useState(false);

  // Search state and handler
  const [searchText, setSearchText] = useState("");
  // Checkbox state and handlers
  const [checkedValues, setCheckedValues] = useState([]);
  const [tempCheckedValues, setTempCheckedValues] = useState([]);
  // Redux state selectors
  const authParams = useSelector((state) => state?.Authentication?.authParams);
  const widgetGraphConfig = useSelector(
    (state) => state?.GraphConfig?.widgetGraphConfig
  );
  const panes = useSelector((state) => state?.Tab1?.panes);
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);
  const Section = useSelector((state) => state?.Section?.addSection);
  const screen = useSelector((state) => state?.Screens?.screen);
  const shareBrands = useSelector((state) => state?.ApiCall?.shareBrands);
  const shareableLinkDeepDiveStatus = useSelector(
    (state) => state?.ApiCall?.shareableLinkDeepDiveStatus
  );
  const shareTemplateData = useSelector(
    (state) => state?.ApiCall?.shareTemplateData
  );
  const deepdiveDashboardData = useSelector(
    (state) => state?.DeepDiveDashboard?.dashboardData
  );
  const deepdiveDashboardTemplateData = useSelector(
    (state) => state?.DeepDiveDashboard?.dashboardTemplateData
  );

  const allAttributes = useSelector(
    (state) => state?.attributes?.allAttributes
  );
  const All_WM_attributes = useSelector(
    (state) => state.WidgetMaker.All_WM_attributes
  );

  // This state store attribute list in dashboard case allAttributes
  // This state store attribute list in widget maker case All_WM_attributes
  const allAttributesList = allAttributes ? allAttributes : All_WM_attributes;

  const isDeepDiveDashboardView = useMemo(() => {
    let pathName = getWindowLocationPath()?.toLowerCase();
    return (
      (authParams?.screen_id
        ? screen?.isDeepDiveDashboard
          ? true
          : false
        : shareableLinkDeepDiveStatus
        ? shareTemplateData?.isDeepDiveDashboard
          ? true
          : false
        : !authParams?.screen_id &&
          !shareBrands &&
          (pathName === "dashboard" || pathName === "pin-dashboard") &&
          !panes?.[getPaneIndex(panes, activeKey)]?.is_widget_maker_open_obj
            ?.open_flag &&
          panes?.[getPaneIndex(panes, activeKey)]?.isDeepDiveDashboard
        ? true
        : false) && !deepdiveDashboardTemplateData?.isDeepDive
    );
  }, [
    screen,
    shareTemplateData,
    panes,
    authParams,
    deepdiveDashboardTemplateData,
  ]);

  const widgetMetaData = useMemo(() => {
    let pathName = getWindowLocationPath()?.toLowerCase();
    let index = getPaneIndex(panes, activeKey);
    let dashboardDataOfDeepDive = deepdiveDashboardData;
    let deepdiveTemplatData = deepdiveDashboardTemplateData;
    let sectionData = isDeepDiveDashboardView
      ? deepdiveTemplatData?.sections?.[section_index]
      : pathName === "edit-dashboard" || pathName === "create-dashboard"
      ? section_index >= 0
        ? Section?.[section_index]
        : Section?.[0]
      : pathName === "CommandCenter"?.toLowerCase()
      ? section_index !== null &&
        section_index !== undefined &&
        screen?.sections &&
        screen?.sections?.[section_index]
        ? screen?.sections?.[section_index]
        : section_index >= 0 &&
          screen?.sections &&
          screen?.sections?.[section_index]
        ? screen?.sections?.[section_index]
        : screen?.section?.[0]
        ? screen?.section?.[0]
        : null
      : shareBrands
      ? shareTemplateData?.section
        ? shareTemplateData?.section?.[0]
        : shareTemplateData?.sections?.[section_index]
      : section_index >= 0 && panes?.[index]?.sections
      ? panes?.[index]?.sections?.[section_index]
      : panes?.[index]?.section?.[0];

    let widget_metadata = isDeepDiveDashboardView
      ? sectionData?.widgets?.[widget_index]
      : pathName === "edit-dashboard" || pathName === "create-dashboard"
      ? sectionData?.data?.[widget_index]
      : pathName === "CommandCenter"?.toLowerCase()
      ? sectionData && sectionData?.widgets?.[widget_index]
        ? sectionData?.widgets?.[widget_index]
        : screen?.widgets && screen?.widgets?.[widget_index]
        ? screen?.widgets && screen?.widgets?.[widget_index]
        : null
      : shareBrands
      ? sectionData?.widgets?.[widget_index]
      : section_index >= 0
      ? sectionData?.widgets?.[widget_index]
      : sectionData?.widgets?.[widget_index];
    return widget_metadata || null;
  }, [
    isDeepDiveDashboardView,
    screen,
    shareBrands,
    shareTemplateData,
    panes,
    authParams,
    deepdiveDashboardTemplateData,
    Section,
  ]);
  // console.log("widgetMetaData", widgetMetaData);

  // Get the current selected value for this dropdown
  const filterByDropdownValues = useMemo(() => {
    // If no value is selected, default to the first option if available
    return (
      widgetMetaData?.filter_by_dropdown?.[filterIndex] ||
      widgetGraphConfig?.filter_by_dropdown?.[filterIndex]
    );
  }, [widgetGraphConfig, filterIndex, widgetMetaData]);
  // console.log("filterByDropdownValues", filterByDropdownValues);

  const filterConfig = useMemo(() => {
    return (
      widgetMetaData?.filter_dropdown?.[filterIndex] ||
      widgetGraphConfig?.filter_dropdown?.[filterIndex]
    );
  }, [widgetGraphConfig, filterIndex, widgetMetaData]);
  // console.log("filterConfig", filterConfig);

  const dropDownDataFromMetaData = useMemo(() => {
    if (!widgetMetaData) return null;
    let pathName = getWindowLocationPath()?.toLowerCase();
    let graphData =
      pathName === "edit-dashboard" || pathName === "create-dashboard"
        ? widgetMetaData?.data
        : widgetMetaData?.graphData || widgetMetaData?.persist_graphdata;
    let dropdownData =
      widgetMetaData?.quickFilterDropdownListInNoData &&
      Array.isArray(widgetMetaData?.quickFilterDropdownListInNoData)
        ? widgetMetaData?.quickFilterDropdownListInNoData
        : typeof graphData === "string"
        ? graphData
        : graphData?.data?.["dropdown"];
    return dropdownData && Array.isArray(dropdownData) ? dropdownData : [];
  }, [widgetMetaData]);
  // console.log("dropDownDataFromMetaData", dropDownDataFromMetaData);

  const dropdownOptions = useMemo(() => {
    if (widgetMetaData && dropDownDataFromMetaData) {
      // If dropDownDataFromMetaData is provided, use it to get dropdown options
      if (!dropDownDataFromMetaData || !Array.isArray(dropDownDataFromMetaData))
        return [];

      // Map the dropDownDataFromMetaData to the expected format for Select options
      return dropDownDataFromMetaData?.[filterIndex]?.map((item) => ({
        value: item.value || item.text,
        text: item.text || item.value,
        highlight: item.highlight || false,
      }));
    } else {
      // If dropDownData is not provided, return an empty array
      if (!dropDownData || !Array.isArray(dropDownData)) return [];

      // Map the dropDownData to the expected format for Select options
      return dropDownData?.[filterIndex]?.map((item) => ({
        value: item.value || item.text,
        text: item.text || item.value,
        highlight: item.highlight || false,
      }));
    }
  }, [dropDownData, dropDownDataFromMetaData]);

  // Determine if multiple selection is enabled for this filter
  const isMultipleSelectionEnabled = useMemo(() => {
    // Use allow_multiple_selection from filterConfig if available, otherwise fallback to isMultiple prop
    return filterConfig?.allow_multiple_selection !== undefined
      ? filterConfig.allow_multiple_selection
      : isMultiple;
  }, [filterConfig, isMultiple]);

  const selectedValue = useMemo(() => {
    // If no filterConfig, return null
    if (!filterConfig) return null;

    // For multiple selection
    if (isMultipleSelectionEnabled) {
      // If no filterByDropdownValues or empty columns, return all dropdown options
      if (
        !filterByDropdownValues?.columns ||
        filterByDropdownValues?.columns.length === 0
      ) {
        // Initially select all values
        return (
          dropdownOptions?.map((option) => option.text || option.value) || []
        );
      }
      // Return array of selected values
      return filterByDropdownValues?.columns?.map((col) => col?.name);
    }

    // For single selection
    if (
      !filterByDropdownValues ||
      filterByDropdownValues?.columns?.[0]?.name === "All" ||
      filterByDropdownValues?.columns?.[0]?.name === null
    ) {
      return "All";
    }
    // Otherwise, return the first value from the selected filter
    return filterByDropdownValues?.columns?.[0]?.name || null;
  }, [
    filterByDropdownValues,
    filterConfig,
    isMultipleSelectionEnabled,
    dropdownOptions,
  ]);
  // Prepare the filter data based on selection type
  const prepareFilterData = (selectedValues) => {
    if (isMultipleSelectionEnabled) {
      // For multiple selection, handle array of values
      if (
        !selectedValues ||
        selectedValues?.length === 0 ||
        // If all values are selected, don't pass filter
        selectedValues?.length === dropdownOptions?.length
      ) {
        return null;
      }
      let selectedValuesArray = Array.isArray(selectedValues)
        ? selectedValues?.map((val) => ({ name: val, type: "include" }))
        : [];
      return {
        columns: selectedValuesArray,
        attribute_id: filterConfig?.attribute_id,
      };
    } else {
      // For single selection
      if (selectedValues?.toLowerCase() === "all" || selectedValues === null) {
        return null;
      }
      return {
        columns: [{ name: selectedValues, type: "include" }],
        attribute_id: filterConfig?.attribute_id,
      };
    }
  };
  // Handle dropdown selection change
  const handleDropdownChange = (value) => {
    if (isPreviewState || PdfDownloadStatus || PptGeneratingStatus) return;

    // Get current path to determine context
    let pathName = getWindowLocationPath();
    let index = getPaneIndex(panes, activeKey);

    let filter_by_dropdown_data;
    let filter_by_dropdown;
    let updatedOrderBy;

    // CONTEXT : Create and Edit Dashboard View
    if (pathName === "edit-dashboard" || pathName === "create-dashboard") {
      // Create And Edit Dashboard View
      if (widgetMetaData) {
        // If the widget is in widget maker mode, update the filter_by_dropdown_data
        filter_by_dropdown_data = widgetMetaData?.filter_by_dropdown_data || [];
        filter_by_dropdown = widgetMetaData?.filter_by_dropdown || [];

        // Prepare the filter data based on selection type
        const filterData = prepareFilterData(value);
        // console.log("Create / Edit filterData:", filterData);
        if (filterData === null) {
          updatedOrderBy = widgetMetaData?.order_by
            ? {
                attribute: widgetMetaData?.order_by?.attribute,
                sort_order: widgetMetaData?.order_by?.sort_order,
                offset: 0,
              }
            : null;
          filter_by_dropdown_data[filterIndex] = null;
          filter_by_dropdown[filterIndex] = null;
        } else {
          filter_by_dropdown_data[filterIndex] = {
            attribute: filterConfig?.attribute,
            data: dropDownDataFromMetaData
              ? dropDownDataFromMetaData?.[filterIndex]
              : dropDownData?.[filterIndex],
          };
          filter_by_dropdown[filterIndex] = {
            attribute: filterConfig?.attribute,
            type: "varchar",
            columns: filterData?.columns,
          };
          updatedOrderBy = widgetMetaData?.order_by
            ? {
                attribute: widgetMetaData?.order_by?.attribute,
                sort_order: widgetMetaData?.order_by?.sort_order,
                offset: 0,
              }
            : null;
        }
        filter_by_dropdown = filter_by_dropdown
          ? filter_by_dropdown?.filter((item) => item?.columns?.length > 0)
          : [];
        filter_by_dropdown_data = filter_by_dropdown_data
          ? filter_by_dropdown_data.filter((item) => item?.data?.length > 0)
          : [];
        let updatedSection = [...Section];
        if (section_index >= 0) {
          if (
            (widgetMetaData?.chart?.chart_type === "post-card" ||
              widgetMetaData?.chart?.chart_type === "review-card") &&
            updatedOrderBy
          ) {
            updatedSection[section_index].data[widget_index].order_by =
              updatedOrderBy;
          }
          updatedSection[section_index].data[
            widget_index
          ].filter_by_dropdown_data = filter_by_dropdown_data;
          updatedSection[section_index].data[widget_index].filter_by_dropdown =
            filter_by_dropdown;

          if (widgetMetaData?.data) {
            updatedSection[section_index].data[widget_index].data = null;
          }
        } else {
          if (
            (widgetMetaData?.chart?.chart_type === "post-card" ||
              widgetMetaData?.chart?.chart_type === "review-card") &&
            updatedOrderBy
          ) {
            updatedSection[0].data[widget_index].order_by = updatedOrderBy;
          }
          updatedSection[0].data[widget_index].filter_by_dropdown_data =
            filter_by_dropdown_data;
          updatedSection[0].data[widget_index].filter_by_dropdown =
            filter_by_dropdown;
          if (widgetMetaData?.data) {
            updatedSection[0].data[widget_index].data = null;
          }
        }
        dispatch({ type: "SET_ADDSECTION", payload: updatedSection });
      }
    }
    // CONTEXT : DeepDive Dashboard View
    else if (
      !deepDive &&
      (((pathName === "dashboard" || pathName === "pin-dashboard") &&
        !panes?.[index]?.is_widget_maker_open_obj?.open_flag &&
        panes?.[index]?.isDeepDiveDashboard) ||
        shareTemplateData?.isDeepDiveDashboard ||
        screen?.isDeepDiveDashboard)
    ) {
      // Handle filter logic for Command Center View
    }
    // CONTEXT : Deep Dive View
    else if (deepDive) {
      // Handle filter logic for Deep Dive View
    }
    // CONTEXT : Shareable Link View
    else if (shareTemplateData) {
      // Share Dashboard View
      if (!widgetMetaData) return;
      // If the widget is in widget maker mode, update the filter_by_dropdown_data
      filter_by_dropdown_data = widgetMetaData?.filter_by_dropdown_data || [];
      filter_by_dropdown = widgetMetaData?.filter_by_dropdown || [];

      // Prepare the filter data based on selection type
      const filterData = prepareFilterData(value);
      // console.log("Share Link View", filterData);
      if (filterData === null) {
        updatedOrderBy = widgetMetaData?.order_by
          ? {
              attribute: widgetMetaData?.order_by?.attribute,
              sort_order: widgetMetaData?.order_by?.sort_order,
              offset: 0,
            }
          : null;
        filter_by_dropdown_data[filterIndex] = null;
        filter_by_dropdown[filterIndex] = null;
      } else {
        filter_by_dropdown_data[filterIndex] = {
          attribute: filterConfig?.attribute,
          data: dropDownDataFromMetaData
            ? dropDownDataFromMetaData?.[filterIndex]
            : dropDownData?.[filterIndex],
        };
        filter_by_dropdown[filterIndex] = {
          attribute: filterConfig?.attribute,
          type: "varchar",
          columns: filterData?.columns,
        };
        updatedOrderBy = widgetMetaData?.order_by
          ? {
              attribute: widgetMetaData?.order_by?.attribute,
              sort_order: widgetMetaData?.order_by?.sort_order,
              offset: 0,
            }
          : null;
      }
      filter_by_dropdown = filter_by_dropdown
        ? filter_by_dropdown?.filter((item) => item?.columns?.length > 0)
        : [];
      filter_by_dropdown_data = filter_by_dropdown_data
        ? filter_by_dropdown_data.filter((item) => item?.data?.length > 0)
        : [];
      let updateShareTemplateData = { ...shareTemplateData };
      if (section_index >= 0) {
        if (
          (widgetMetaData?.chart?.chart_type === "post-card" ||
            widgetMetaData?.chart?.chart_type === "review-card") &&
          updatedOrderBy
        ) {
          updateShareTemplateData.sections[section_index].widgets[
            widget_index
          ].order_by = updatedOrderBy;
        }
        updateShareTemplateData.sections[section_index].widgets[
          widget_index
        ].filter_by_dropdown_data = filter_by_dropdown_data;
        updateShareTemplateData.sections[section_index].widgets[
          widget_index
        ].filter_by_dropdown = filter_by_dropdown;

        if (widgetMetaData?.graphData) {
          updateShareTemplateData.sections[section_index].widgets[
            widget_index
          ].graphData = null;
        }
        if (widgetMetaData?.persist_graphdata) {
          updateShareTemplateData.sections[section_index].widgets[
            widget_index
          ].persist_graphdata = null;
        }
        if (widgetMetaData?.deep_dive_on) {
          updateShareTemplateData.sections[section_index].widgets[
            widget_index
          ].deep_dive_on = null;
        }
      } else {
        if (
          (widgetMetaData?.chart?.chart_type === "post-card" ||
            widgetMetaData?.chart?.chart_type === "review-card") &&
          updatedOrderBy
        ) {
          updateShareTemplateData.section[0].widgets[widget_index].order_by =
            updatedOrderBy;
        }
        updateShareTemplateData.section[0].widgets[
          widget_index
        ].filter_by_dropdown_data = filter_by_dropdown_data;
        updateShareTemplateData.section[0].widgets[
          widget_index
        ].filter_by_dropdown = filter_by_dropdown;
        if (widgetMetaData?.graphData) {
          updateShareTemplateData.section[0].widgets[widget_index].graphData =
            null;
        }
        if (widgetMetaData?.persist_graphdata) {
          updateShareTemplateData.section[0].widgets[
            widget_index
          ].persist_graphdata = null;
        }
        if (widgetMetaData?.deep_dive_on) {
          updateShareTemplateData.section[0].widgets[
            widget_index
          ].deep_dive_on = null;
        }
      }
      dispatch({
        type: "SET_SHARE_TEMPLATE_DATA",
        payload: updateShareTemplateData,
      });
    }
    // CONTEXT : Widget Maker View
    else if (
      panes?.[index]?.is_widget_maker_open_obj?.open_flag ||
      pathName === "widgetMaker" ||
      pathName === "edit-widget"
    ) {
      // If the widget is in widget maker mode, update the filter_by_dropdown_data
      filter_by_dropdown_data =
        widgetGraphConfig?.filter_by_dropdown_data || [];
      filter_by_dropdown = widgetGraphConfig?.filter_by_dropdown || [];

      // Prepare the filter data based on selection type
      const filterData = prepareFilterData(value);
      // console.log("Widget Maker filterData:", filterData);
      if (filterData === null) {
        filter_by_dropdown_data[filterIndex] = null;
        filter_by_dropdown[filterIndex] = null;
      } else {
        filter_by_dropdown_data[filterIndex] = {
          attribute: filterConfig?.attribute,
          data: dropDownDataFromMetaData
            ? dropDownDataFromMetaData?.[filterIndex]
            : dropDownData?.[filterIndex],
        };
        filter_by_dropdown[filterIndex] = {
          attribute: filterConfig?.attribute,
          type: "varchar",
          columns: filterData?.columns,
        };
      }
      // if (value?.toLowerCase() === "all" || value === null) {
      //   filter_by_dropdown_data[filterIndex] = null;
      //   filter_by_dropdown[filterIndex] = null;
      // } else {
      //   filter_by_dropdown_data[filterIndex] = {
      //     attribute: filterConfig?.attribute,
      //     data: dropDownData?.[filterIndex],
      //   };
      //   filter_by_dropdown[filterIndex] = {
      //     attribute: filterConfig?.attribute,
      //     type: "varchar",
      //     columns: [{ name: value, type: "include" }],
      //   };
      // }
      filter_by_dropdown = filter_by_dropdown
        ? filter_by_dropdown?.filter((item) => item?.columns?.length > 0)
        : [];
      filter_by_dropdown_data = filter_by_dropdown_data
        ? filter_by_dropdown_data.filter((item) => item?.data?.length > 0)
        : [];
      dispatch(
        setY_attribute({
          ...widgetGraphConfig,
          [`order_by`]: widgetGraphConfig?.order_by
            ? {
                ...widgetGraphConfig?.order_by,
                offset: 0,
              }
            : null,
          [`filter_by_dropdown`]: filter_by_dropdown,
          [`filter_by_dropdown_data`]: filter_by_dropdown_data,
        })
      );
    }
    // CONTEXT : View Dashboard View
    else {
      // View Dashboard View
      if (!widgetMetaData) return;
      if (!isPreviewState) {
        // If the widget is in widget maker mode, update the filter_by_dropdown_data
        filter_by_dropdown_data = widgetMetaData?.filter_by_dropdown_data || [];
        filter_by_dropdown = widgetMetaData?.filter_by_dropdown || [];

        // Prepare the filter data based on selection type
        const filterData = prepareFilterData(value);
        // console.log(" View Dashboard View", filterData);
        if (filterData === null) {
          updatedOrderBy = widgetMetaData?.order_by
            ? {
                attribute: widgetMetaData?.order_by?.attribute,
                sort_order: widgetMetaData?.order_by?.sort_order,
                offset: 0,
              }
            : null;
          filter_by_dropdown_data[filterIndex] = null;
          filter_by_dropdown[filterIndex] = null;
        } else {
          filter_by_dropdown_data[filterIndex] = {
            attribute: filterConfig?.attribute,
            data: dropDownDataFromMetaData
              ? dropDownDataFromMetaData?.[filterIndex]
              : dropDownData?.[filterIndex],
          };
          filter_by_dropdown[filterIndex] = {
            attribute: filterConfig?.attribute,
            type: "varchar",
            columns: filterData?.columns,
          };
          updatedOrderBy = widgetMetaData?.order_by
            ? {
                attribute: widgetMetaData?.order_by?.attribute,
                sort_order: widgetMetaData?.order_by?.sort_order,
                offset: 0,
              }
            : null;
        }
        filter_by_dropdown = filter_by_dropdown
          ? filter_by_dropdown?.filter((item) => item?.columns?.length > 0)
          : [];
        filter_by_dropdown_data = filter_by_dropdown_data
          ? filter_by_dropdown_data.filter((item) => item?.data?.length > 0)
          : [];
        let updatePanes = [...panes];

        if (section_index >= 0) {
          if (
            (widgetMetaData?.chart?.chart_type === "post-card" ||
              widgetMetaData?.chart?.chart_type === "review-card") &&
            updatedOrderBy
          ) {
            updatePanes[index].sections[section_index].widgets[
              widget_index
            ].order_by = updatedOrderBy;
          }
          updatePanes[index].sections[section_index].widgets[
            widget_index
          ].filter_by_dropdown_data = filter_by_dropdown_data;
          updatePanes[index].sections[section_index].widgets[
            widget_index
          ].filter_by_dropdown = filter_by_dropdown;

          if (widgetMetaData?.graphData) {
            updatePanes[index].sections[section_index].widgets[
              widget_index
            ].graphData = null;
          }
          if (widgetMetaData?.persist_graphdata) {
            updatePanes[index].sections[section_index].widgets[
              widget_index
            ].persist_graphdata = null;
          }
          if (widgetMetaData?.deep_dive_on) {
            updatePanes[index].sections[section_index].widgets[
              widget_index
            ].deep_dive_on = null;
          }
        } else {
          if (
            (widgetMetaData?.chart?.chart_type === "post-card" ||
              widgetMetaData?.chart?.chart_type === "review-card") &&
            updatedOrderBy
          ) {
            updatePanes[index].section[0].widgets[widget_index].order_by =
              updatedOrderBy;
          }
          updatePanes[index].section[0].widgets[
            widget_index
          ].filter_by_dropdown_data = filter_by_dropdown_data;
          updatePanes[index].section[0].widgets[
            widget_index
          ].filter_by_dropdown = filter_by_dropdown;

          if (widgetMetaData?.graphData) {
            updatePanes[index].section[0].widgets[widget_index].graphData =
              null;
          }
          if (widgetMetaData?.persist_graphdata) {
            updatePanes[index].section[0].widgets[
              widget_index
            ].persist_graphdata = null;
          }
          if (widgetMetaData?.deep_dive_on) {
            updatePanes[index].section[0].widgets[widget_index].deep_dive_on =
              null;
          }
        }
        dispatch({ type: "SET_WIDGET_GRAPH_DATA", panes: updatePanes });
      }
    }
  };
  // Filter options based on search
  const filteredOptions = useMemo(() => {
    if (!searchText) return dropdownOptions;
    return dropdownOptions?.filter((option) =>
      (option.text || option.value)
        .toLowerCase()
        .includes(searchText.toLowerCase())
    );
  }, [dropdownOptions, searchText]);

  // console.log(
  //   "FilterByDropDown rendered with options:",
  //   dropdownOptions,
  //   filterIndex,
  //   filterConfig,
  //   selectedValue
  // );

  // Initialize checkedValues and tempCheckedValues when component mounts or selectedValue changes
  useEffect(() => {
    if (isMultipleSelectionEnabled && selectedValue) {
      setCheckedValues(selectedValue);
      setTempCheckedValues(selectedValue);
    }
  }, [selectedValue, isMultipleSelectionEnabled]);

  // If no options are available, don't render the dropdown
  if (!dropdownOptions || dropdownOptions?.length === 0) return null;

  const handleVisibleChange = (newVisible) => {
    if (newVisible) {
      // For multiple selection, if selectedValue is empty, select all options
      if (
        isMultipleSelectionEnabled &&
        (!selectedValue || selectedValue.length === 0)
      ) {
        setTempCheckedValues(
          dropdownOptions?.map((option) => option.text || option.value) || []
        );
      } else {
        setTempCheckedValues(selectedValue || []);
      }
    }
    setVisible(newVisible);
    setVisibleOfTooltip(false);
  };
  const handleVisibleChangeOfTooltip = (newVisible) => {
    setVisibleOfTooltip(newVisible);
  };
  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  const handleCheckboxChange = (checkedValues) => {
    setTempCheckedValues(checkedValues);

    // If all options are now selected, this was likely a result of checking the last unchecked item
    // If some options are selected but not all, this was likely unchecking an individual item
    // We don't need to do anything special here as the helper functions will handle the "All" checkbox state
  };

  // Handle individual checkbox change
  const handleIndividualCheckboxChange = (value, checked) => {
    let newCheckedValues;

    if (checked) {
      // Add the value to checked values
      newCheckedValues = [...tempCheckedValues, value];
    } else {
      // Remove the value from checked values
      newCheckedValues = tempCheckedValues.filter((item) => item !== value);
    }

    setTempCheckedValues(newCheckedValues);
  };

  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;

    if (isChecked) {
      // When "All" is checked, select all options
      const allValues = dropdownOptions.map(
        (option) => option.text || option.value
      );
      setTempCheckedValues(allValues);
    } else {
      // When "All" is unchecked, deselect all options
      setTempCheckedValues([]);
    }
  };

  // Helper function to determine if all items are selected
  const isAllSelected = () => {
    if (!dropdownOptions || dropdownOptions.length === 0) return false;
    return tempCheckedValues.length === dropdownOptions.length;
  };

  // Helper function to determine if some items are selected (for indeterminate state)
  const isSomeSelected = () => {
    return (
      tempCheckedValues.length > 0 &&
      tempCheckedValues.length < dropdownOptions.length
    );
  };

  // Done, Clear, and Cancel handlers
  const handleDone = () => {
    setCheckedValues(tempCheckedValues);
    handleDropdownChange(tempCheckedValues);
    setVisible(false);
    setVisibleOfTooltip(false);
    setSearchText("");
  };

  const handleClear = () => {
    setTempCheckedValues([]);
  };

  const handleCancel = () => {
    setVisible(false);
    setVisibleOfTooltip(false);
    setSearchText("");
    setTempCheckedValues(selectedValue || []);
  };

  // Generate tooltip content for the filter button
  const getTooltipContent = () => {
    const header =
      filterConfig?.trace_name || allAttributesList[filterConfig?.attribute];

    if (!header) return null;

    // For multiple selection
    if (isMultipleSelectionEnabled) {
      const isAllItemsSelected =
        tempCheckedValues.length === dropdownOptions?.length;

      if (isAllItemsSelected || tempCheckedValues.length === 0) {
        return (
          <div>
            <div
              className="border-bottom border-color"
              style={{ fontWeight: "bold", marginBottom: "4px" }}
            >
              {header}
            </div>
            <div>All</div>
          </div>
        );
      } else {
        return (
          <div>
            <div
              className="border-bottom border-color"
              style={{ fontWeight: "bold", marginBottom: "4px" }}
            >
              {header}
            </div>
            <div
              className="custom-scroll"
              style={{ maxHeight: "200px", overflow: "auto" }}
            >
              {tempCheckedValues.map((value, index) => (
                <div key={index}>{value}</div>
              ))}
            </div>
          </div>
        );
      }
    } else {
      // For single selection
      const displayValue =
        selectedValue === "All" || !selectedValue ? "All" : selectedValue;
      return (
        <div>
          <div
            className="border-bottom border-color"
            style={{ fontWeight: "bold", marginBottom: "4px" }}
          >
            {header}
          </div>
          <div>{displayValue}</div>
        </div>
      );
    }
  };

  // Multiple selection popover content
  const popoverContent = (
    <div className="filter-dropdown-popover">
      <div className="filter-dropdown-search">
        <Input
          placeholder={`Search ${
            filterConfig?.trace_name ||
            allAttributesList[filterConfig?.attribute]
              ? filterConfig?.trace_name ||
                allAttributesList[filterConfig?.attribute]
              : "Filter"
          }`}
          value={searchText}
          onChange={handleSearch}
          className="filter-dropdown-search-input"
        />
      </div>
      <div className="filter-dropdown-options">
        <div
          className="filter-dropdown-option"
          style={{
            borderBottom: "1px solid var(--locobuzz-border-color)",
            paddingBottom: "8px",
            marginBottom: "8px",
          }}
        >
          <Checkbox
            checked={isAllSelected()}
            indeterminate={isSomeSelected()}
            onChange={handleSelectAll}
          >
            All
          </Checkbox>
        </div>
        <div className="filter-dropdown-checkbox-group">
          {filteredOptions.map((option) => (
            <div key={option.value} className="filter-dropdown-option">
              <Checkbox
                checked={tempCheckedValues.includes(
                  option.text || option.value
                )}
                onChange={(e) =>
                  handleIndividualCheckboxChange(
                    option.text || option.value,
                    e.target.checked
                  )
                }
              >
                {option.text || option.value}
              </Checkbox>
            </div>
          ))}
        </div>
      </div>
      <div className="filter-dropdown-actions">
        <Button onClick={handleClear} className="btn_Clear">
          Clear
        </Button>
        <div>
          <Button onClick={handleCancel} className="btn_Clear">
            Cancel
          </Button>
          <Button
            type="primary"
            className={`ant-btn-primary_blue`}
            onClick={handleDone}
            disabled={tempCheckedValues?.length === 0}
          >
            Done
          </Button>
        </div>
      </div>
    </div>
  );

  return (
    <div
      className={`ml-2 mr-2 widget-filter-dropdown ${
        (filterConfig?.trace_name ||
          allAttributesList[filterConfig?.attribute]) &&
        false // for now hide
          ? "has-label"
          : ""
      } ${widgetMetaData?.span === "one_third" ? "compact-mode" : ""}`}
    >
      {(filterConfig?.trace_name ||
        allAttributesList[filterConfig?.attribute]) &&
        false && ( // for now hide
          <div className="filter-dropdown-label ml-2 mr-2">
            {filterConfig?.trace_name ||
              allAttributesList[filterConfig?.attribute]}
          </div>
        )}
      {isMultipleSelectionEnabled ? (
        <>
          <Popover
            content={popoverContent}
            title={null}
            trigger="click"
            placement="bottomLeft"
            open={visible}
            onOpenChange={handleVisibleChange}
            overlayClassName="filter-dropdown-popover-container"
          >
            <Tooltip
              title={getTooltipContent()}
              open={
                !visible &&
                visibleOfTooltip &&
                (filterConfig?.trace_name ||
                  allAttributesList[filterConfig?.attribute])
                  ? undefined
                  : false
              }
              onOpenChange={(e) => {
                handleVisibleChangeOfTooltip(e);
              }}
              placement="top"
              overlayStyle={{ maxWidth: "300px" }}
            >
              <Button
                className={`filter-dropdown-button ${
                  tempCheckedValues?.length > 0 &&
                  tempCheckedValues?.length !== dropdownOptions?.length
                    ? "has-selection"
                    : ""
                } ${widgetMetaData?.span === "one_third" ? "icon-only" : ""}`}
                disabled={
                  isPreviewState || PdfDownloadStatus || PptGeneratingStatus
                }
                style={type === "widgetMaker" ? { height: "4rem" } : {}}
                onClick={(e) => e.stopPropagation()}
              >
                <span className="filter-dropdown-icon">
                  <img src={quickFilterIcon} />
                </span>
                {widgetMetaData?.span !== "one_third" ? (
                  <span className="button-text">
                    {tempCheckedValues.length > 0 ? (
                      tempCheckedValues.length === dropdownOptions?.length ? (
                        "All"
                      ) : tempCheckedValues.length === 1 ? (
                        <span className="primary-text">
                          {tempCheckedValues[0]}
                        </span>
                      ) : (
                        <>
                          <span className="primary-text">
                            {tempCheckedValues[0]}
                          </span>
                          <span className="count-indicator">
                            +{tempCheckedValues.length - 1}
                          </span>
                        </>
                      )
                    ) : dropdownOptions?.length > 0 ? (
                      "All"
                    ) : (
                      "Select multiple values"
                    )}
                  </span>
                ) : (
                  ""
                )}
              </Button>
            </Tooltip>
          </Popover>
        </>
      ) : (
        <Select
          className={`filter-dropdown-select border-radius-4 SingleBrands__dropdown--popup ${
            selectedValue && selectedValue !== "All" ? "has-value" : ""
          }`}
          value={selectedValue || "All"}
          onChange={handleDropdownChange}
          style={{
            width: "100%",
            minWidth: "12rem",
            maxWidth: authParams?.screen_id === "000-000-557" ? "" : "20rem",
            height: "3.2rem",
          }}
          disabled={isPreviewState || PdfDownloadStatus || PptGeneratingStatus}
          placeholder="Select"
          popupClassName={`${
            authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
          } SingleBrands__dropdown--list color-palette-dropdown`}
          dropdownMatchSelectWidth={false}
          optionFilterProp="children"
          filterOption={(input, option) =>
            (option?.label ?? "")?.toLowerCase()?.includes(input?.toLowerCase())
          }
        >
          <Select.Option key="All" value="All" className="color-option">
            All
          </Select.Option>
          {dropdownOptions.map((option) => (
            <Select.Option
              key={option.text || option.value}
              value={option.text || option.value}
              className="color-option"
            >
              {option.text || option.value}
            </Select.Option>
          ))}
        </Select>
      )}
    </div>
  );
};

export default React.memo(FilterByDropDown, isEqual);
